import {
  readQueryParamNumber,
  readQueryParamString,
} from "/Helpers/readQueryParam";
import BaseSearchClient, { BaseListResult } from "/Helpers/BaseSearchClient";
import { NewsListFilters } from "./NewsListPage";

export interface NewsListResults extends BaseListResult {}
export default class NewsListClient extends BaseSearchClient {
  public GetItems = (filters: NewsListFilters): Promise<NewsListResults> => {
    const query = this.ToQueryString(filters, {
      language: this.language,
      newsListPageId: this.pageId?.toString(),
    });
    return fetch(`${this.endpoint}?${query}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error from event list API");
        }
        return response.json();
      })
      .catch((error) => {
        //gracefull return
        return { error: true, message: error.message };
      });
  };

  public BuildUrlFromProps = (filters: NewsListFilters): string | undefined =>
    this._baseUrl
      ? `${this._baseUrl}?${this.ToQueryString(filters)}`
      : undefined;

  // Same parameter names for the page URL and /api/newsList, read on the server by QueryParameterService.
  // Built by hand: this also runs during server-side rendering, where URLSearchParams doesn't exist.
  private ToQueryString = (
    {
      pageNumber,
      searchTerm,
      area,
      theme,
      year,
      fuzzySearch,
      sortByRelevance,
    }: NewsListFilters,
    extra: Record<string, string | null | undefined> = {},
  ) =>
    Object.entries({
      page: `${pageNumber}`,
      term: searchTerm,
      publicationarea: area,
      publicationtheme: theme,
      year: year ? `${year}` : undefined,
      fuzzy: fuzzySearch ? "true" : undefined,
      sortby: sortByRelevance ? "relevance" : undefined,
      ...extra,
    })
      .filter(([, value]) => value)
      .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
      .join("&");

  private GetPageNumberFromUrl = (): number =>
    readQueryParamNumber("page") ?? 1;

  public GetParams = () => {
    return {
      pageNumber: this.GetPageNumberFromUrl(),
      searchTerm: readQueryParamString("term") ?? "",
      area: readQueryParamString("publicationarea") ?? "",
      theme: readQueryParamString("publicationtheme") ?? "",
      year: readQueryParamNumber("year") ?? undefined,
      fuzzySearch: readQueryParamString("fuzzy") === "true",
      sortByRelevance: readQueryParamString("sortby") === "relevance",
    };
  };
}
